import React from "react";
import { Tooltip } from "@mantine/core";

const TVLegends = () => {
  const deskStatusBasic = [
    { status: "Occupied", color: "red", desc: "Desk is currently being used." },
    {
      status: "Available",
      color: "green",
      desc: "Desk is free and can be used immediately.",
    },
    {
      status: "Occupied Away ",
      color: "orange",
      desc: "Assigned desk temporarily not in use; user expected to return.",
    },
    {
      status: "Blocked",
      color: "blue",
      desc: "Desk not available for use due to various operational reasons.",
    },
  ];

  return (
    <div className="flex gap-[.8vw] items-center  flex-wrap">
      {deskStatusBasic.map((desk) => {
        return (
          <div
            className="flex gap-[.6vw] items-center px-[.7vw] py-[.7vh]   border-[.02vw] border-solid rounded-[1vw] border-grayText4 hover:bg-lightGray"
            key={desk.status}
          >
            <div
              className="w-[.5vw] h-[.5vw] rounded-[50%] "
              style={{ background: desk.color }}
            />

            <p className="text-[.8vw]">{desk.status}</p>
          </div>
        );
      })}
    </div>
  );
};

export default TVLegends;
